  import { Dropdown, Input } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { ColDef } from 'ag-grid-community'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { RootDispatch } from '../../app/store'
import { getMemberPointPage } from './MembersManagementPageSlice'
import styles from '../../compnents/simpleTable/SimpleAgGrid.module.css'
import styles2 from './MembersManagementPage.module.css'

interface ExchangeItemSelectProps {
  category: 'goods' | 'treatment'
  value?: any
  memberPoint?: number | string
  onChange?: (item: any) => void
}

export const ExchangeItemSelect = ({
  category,
  value,
  memberPoint,
  onChange,
}: ExchangeItemSelectProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(1)
  const [selectedItem, setSelectedItem] = useState<any>(value || null)
  const [searchText, setSearchText] = useState(selectedItem?.name || '')
  const size = 5
  const composingRef = useRef(false)

  const timerRef = useRef<any>(null)

  const fetchData = (page: number, kw?: string) => {
    setLoading(true)
    const keyword = kw !== undefined ? kw : searchText
    const params: any = {
      current: page,
      size,
      isExchange: 0,
      catalogType: category === 'goods' ? 0 : 1,
      memberPoint,
      flag: true,
    }

    params.keyWord = keyword

    dispatch(getMemberPointPage(params))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res?.records || [])
        setTotal(res?.total || 0)
      })
      .catch(() => {
        setData([])
        setTotal(0)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (open && !composingRef.current) {
      setCurrent(1)
      fetchData(1)
    }
  }, [open, category])

  // 切换类别时清空输入框
  useEffect(() => {
    setSelectedItem(null)
    setSearchText('')
    onChange?.(null)
  }, [category])

  // 输入变更时防抖重新查询
  useEffect(() => {
    if (!open || composingRef.current) return
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setCurrent(1)
      fetchData(1)
    }, 300)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [searchText])

  const handleSelect = (item: any) => {
    console.log(item);
    
    setSelectedItem(item)
    setSearchText(item?.name || '')
    onChange?.(item)
    setOpen(false)
  }

  const columnDefs: ColDef[] = [
    {
      field: 'name',
      headerName: category === 'goods' ? '商品信息' : '诊疗信息',
      flex: 1,
      minWidth: 200,
      sortable: false,
    },
    {
      field: 'point',
      headerName: '积分',
      width: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
  ]

  const overlay = (
    <div style={{ width: 500, height: 260 }} className={`${styles.container} ${styles2.exchangeDropdown}`}>
      <SimpleAgGrid
        rowHeight={36}
        headerHeight={32}
        column={columnDefs}
        page={{ items: data, current, size, total }}
        isLoading={loading}
        pagination={true}
        showSizeChanger={false}
        showQuickJumper={false}
        pageSizeOptions={[5]}
        defaultPageSize={5}
        rowSelection="single"
        suppressRowClickSelection={false}
        onChangePage={(p) => {
          setCurrent(p)
          fetchData(p)
        }}
        onSelectionChange={(selectedRows: any[]) => {
          if (selectedRows.length > 0) handleSelect(selectedRows[0])
        }}
      />
    </div>
  )

  return (
    <Dropdown
      overlay={overlay}
      trigger={[]}
      visible={open}
      onVisibleChange={(v) => {
        if (!v) setOpen(false)
      }}
      placement="bottomLeft"
    >
      <Input
        value={searchText}
        placeholder="请选择/搜索项目"
        style={{ width: 240 }}
        allowClear
        onCompositionStart={() => { composingRef.current = true }}
        onCompositionEnd={(e: any) => {
          composingRef.current = false
          const val = e.target.value
          setSearchText(val)
          if (open && val) {
            if (timerRef.current) clearTimeout(timerRef.current)
            timerRef.current = setTimeout(() => {
              setCurrent(1)
              fetchData(1, val)
            }, 300)
          }
        }}
        onChange={(e) => {
          const val = e.target.value
          setSearchText(val)
          if (!val) {
            setSelectedItem(null)
            onChange?.(null)
          } else if (selectedItem?.name !== val) {
            setSelectedItem(null)
            onChange?.(null)
          }
        }}
        onClick={() => {
          setOpen(true)
        }}
        onBlur={async (e: any) => {
          await new Promise((r) => setTimeout(r, 200))
          if (!e.relatedTarget?.closest('.ant-dropdown')) {
            setOpen(false)
          }
        }}
      />
    </Dropdown>
  )
}
